<button appUITooltip
  ttitle="Copied to clipboard"
  placement="left"
  class="btn btn-primary py-1 px-2 rounded text-uppercase bg-light-blue position-relative display-flex"
  (click)="buttonClicked()"
  [disabled]="selectedItemsCount | disableCopy">
  <i class="icon18 se-icon-action_copy mb-1 iconSize pl-1"></i>
  <div class="font-weight-bolder font-size-xs d-inline-block py-1 align-text-top" [ngClass]="!(selectedItemsCount | disableCopy) ? 'pt-1' : 'py-1'">
    <ng-container i18n="@@app.copy_transfer">Copy/Transfer</ng-container>
    @if (!(selectedItemsCount | disableCopy)) {
      <span class="badge bg-light-blue border-solid border-width-2 border-white position-absolute right-0">{{selectedItemsCount}}</span>
    }
  </div>
</button>

